import React, { Component } from "react";
import { DatePicker, Button, Select,AutoComplete,Input, Cascader } from "antd";
import SearchRetrieve from "../../common/SearchRetrieve.new";
import API_URL from "../../../common/url";
import $ from "../../../common/AjaxRequest";
import dictCache from '../../../common/dictCache';
import FilterBasic from '../../basicElement/FilterBasic';
import moment from "moment";

const monthFormat = "YYYY-MM";
const { MonthPicker } = DatePicker;
const { Option } = Select;
const errorList = [
    { errorReason: "完工百分比≥10%" },
    { errorReason: "当月收入≥20万" },
    { errorReason: "当月收入≤-5万" },
    { errorReason: "项目到达完工结束月" },
    { errorReason: "截至本月末完工%＞100%" },
    { errorReason: "当月完工百分比＜-5%" },
];
const MedicineTypeList = [
    {value: 'Research_drugs', label: '药物'},
    {
        value: 'Technology', 
        label: '技术类',
        children: [
            {
                value: 'Radiation_therapy', 
                label: '放射疗法（同位素 核药；照射）',
            },
            {
                value: 'Cell_therapy', 
                label: '细胞治疗: CART',
            },
            {
                value: 'Stem_cell_therapy', 
                label: '干细胞治疗',
            },
            {
                value: 'Organ_transplant', 
                label: '器官移植',
            },
            {
                value: 'Gene_therapy', 
                label: '基因治疗',
            },
            {
                value: 'Dialysis', 
                label: '透析',
            },
        ]
    },
    {value: 'Medical_instruments', label: '医疗器械'},
    {value: 'Vaccines', label: '疫苗'},
    {value: 'Diagnostic_reagent', label: '诊断试剂'},
    {value: 'Others', label: '其他'},
]

class Filter extends Component {
    state = {
        maxDate: moment(),
        saveParams: {},
        businessList:[],
        byStageList: [],
        diseaseList:[],
        areaList:[],
        typeList:[],
        contractTypeList:[]
    };

    componentDidMount() {
        this.getDate();
        this.queryWithLevelByParams();
        this.loadTypeConfigureList();
    }

    getDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: "POST",
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: "json",
                doneResult: res => cb(res),
            });
        }, (res) => {
            const { date } = res;
            const nowT = moment(date).format("YYYY-MM-DD HH:mm");
            const nowM = moment(date).format("YYYY-MM");
            const canMark = `${nowM}-28 12:00` < nowT;
            const { saveParams = {} } = this.state;
            this.setState({
                saveParams: {
                    ...saveParams,
                    date: canMark
                        ? nowM
                        : moment(nowM).subtract(1, "M").format("YYYY-MM"),
                },
            });
        });
    };

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => this.setState({ businessList: res.typeConfigureList || [] }));
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                areaList: res.areaList,
                // levelList: res.levelList,
                typeList: res.typeList,
                // stageList: res.stageList,
                // testeeTypeList: res.testeeTypeList,
                contractTypeList: res.contractTypeList,
            });
        })
    }


    loadInvestigationByStageList = () => {
        const { saveParams: { investigationMedicineType = [] } } = this.state;
        if (investigationMedicineType[0]) {
            const options = {
                method: 'POST',
                url: API_URL.common.queryInvestigationByStageByMedicine,
                data: { investigationMedicineType: investigationMedicineType[0] },
                dataType: 'json',
                doneResult: res => {
                    this.setState({ byStageList: res.data });
                }
            }
            $.sendRequest(options);
        } else {
            this.setState({ byStageList: [] });
        }
    }

    loadDiseaseList = (value) => {
        const { saveParams: { investigationAreaId } } = this.state;
        if (investigationAreaId) {
            const options = {
                method: 'POST',
                url: API_URL.common.queryAllDisease,
                data: {
                    keyword: value,
                    investigationAreaId,
                },
                dataType: 'json',
                doneResult: res => {
                    this.setState({ diseaseList: res.data });
                }
            };
            $.sendRequest(options);
        } else {
            this.setState({ diseaseList: [] });
        }
    }

    search = () => {
        const { saveParams } = this.state;
        this.props.search(saveParams);
    };

    disabledDate = (current) => {
        const { maxDate } = this.state;
        const value = moment(maxDate).valueOf();
        return current && current.valueOf() > value;
    };
    handleFilterChange = (saveParams) => {
        this.setState({ saveParams: {...saveParams} });
    }
    handleChange = (value, key) => {
        const { saveParams } = this.state;
        switch (key) {
            case 'investigation': {
                const { value: id, text: name } = value;
                saveParams[`${key}Id`] = id;
                saveParams[`${key}Name`] = name;
                this.handleFilterChange(saveParams);
                break;
            }
            case 'lineOfBusiness':
                saveParams[key] = value;
                saveParams.secondLineName = undefined;
                this.handleFilterChange(saveParams);
                break;
            case 'investigationMedicineType':
                saveParams[key] = value;
                saveParams.byStageName = undefined;
                this.handleFilterChange(saveParams);
                this.loadInvestigationByStageList();
                break;
            case 'investigationAreaId':
                saveParams[key] = value;
                saveParams.diseaseId = undefined;
                saveParams.diseaseName = undefined;
                this.handleFilterChange(saveParams);
                this.loadDiseaseList();
                break;
            case "diseaseId":{
                value?saveParams.diseaseId=value:saveParams.diseaseId = undefined;
                saveParams.diseaseName = undefined;
                this.handleFilterChange(saveParams);
                break;
            }
            case 'leaderName': {
                const { value: id, text: name } = value;
                saveParams[`${key}Field`] = id;
                saveParams[`${key}`] = name;
                this.handleFilterChange(saveParams);
                break;
            }
            case 'pm': {
                const { text: name } = value;
                saveParams[`pm`] = name;
                this.handleFilterChange(saveParams);
                break;
            }
            default:
                saveParams[key] = value;
                this.handleFilterChange(saveParams);
                break;
        }
        this.setState({ saveParams });
    };

    render() {
        const { operable } = this.props;
        const { saveParams,businessList,diseaseList,areaList,byStageList,typeList,contractTypeList } = this.state;
        const errorOption = errorList.map(d => <Option key={d.errorReason}>{d.errorReason}</Option>);
        //研究产品类型
        const medicineTypeOptions = MedicineTypeList.map(d => <Option key={String(d.value)} title={d.label}>{d.label}</Option>);
        //项目分期
        const byStageOption = byStageList.map(d => <Option key={String(d.investigationByStageName)} title={d.investigationByStageName}>{d.investigationByStageName}</Option>);
        //项目分类
        const typeOption = typeList.map(d => <Option key={String(d.typeValue)} title={d.typeValue}>{d.typeValue}</Option>);
        //计收入确认访视
        const contractTypeListOption = contractTypeList.map(d => <Option key={String(d.typeValue)} title={d.typeValue}>{d.typeValue}</Option>);
        //业务线
        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        // 执行业务线二级分类
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (saveParams.lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });
        const secondLineOption = [...secondLineSet].map(d => <Option key={d} title={d}>{d}</Option>);
        //项目领域
        const areaListOption = areaList.map(d => <Option key={String(d.investigationAreaId)} title={d.investigationAreaName}>{d.investigationAreaName}</Option>);
        //疾病
        const diseaseOption = diseaseList.map(d => <Option key={String(d.diseaseId)} showValue={d.diseaseName} title={d.diseaseName}>{d.diseaseName}</Option>);
        return (
            <div className="search-bar" style={{ marginBottom: 16 }}>
                <div className="search-item" style={{ marginTop: 5 }}>
                    <label className="ui-label" style={{ marginRight: 10 }}>
                        异常月份
                    </label>
                    <MonthPicker
                        format={monthFormat}
                        value={saveParams.date ? moment(saveParams.date) : null}
                        onChange={(date, dateString) => this.handleChange(dateString, "date")}
                        disabledDate={this.disabledDate}
                        allowClear={false}
                        style={{ width: 100, verticalAlign: "middle" }}
                    />
                </div>
                <div className="search-item" style={{ marginLeft: 10 }}>
                    <label className="ui-label">项目简称</label>
                    <SearchRetrieve
                        keyword="investigationName"
                        style={{ width: 162 }}
                        placeholder="输入名称检索"
                        params={{ limit: 20 }}
                        value={saveParams.investigationName}
                        url={API_URL.investigation.queryInvestigationByName}
                        config={{ id: "investigationId", name: "investigationName" }}
                        onChange={value => this.handleChange(value, 'investigation')}
                    />
                </div>
                <div className="search-item">
                    <div className="ui-label">JDE主项目号</div>
                    <Input
                        placeholder="请输入"
                        style={{ width: 120 }}
                        value={saveParams.mainCode}
                        // onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleChange(e.target.value, 'mainCode')}
                    />
                </div>
                <div className="search-item">
                    <div className="ui-label">JDE项目号</div>
                    <Input
                        placeholder="请输入"
                        style={{ width: 120 }}
                        value={saveParams.jdeCode}
                        // onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleChange(e.target.value, 'jdeCode')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">研究产品类型</label>
                    <Cascader
                        style={{ width: 150 }}
                        allowClear={true}
                        placeholder="请选择"
                        options={MedicineTypeList}
                        value={saveParams.investigationMedicineType}
                        onChange={value => this.handleChange(value, 'investigationMedicineType')}
                    />
                </div>
                <div className="search-item showInvestigation">
                    <label htmlFor="" className="ui-label">项目分期</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{ width: 120 }}
                        disabled={!(saveParams.investigationMedicineType || [])[0]}
                        value={saveParams.byStageName}
                        onChange={value => this.handleChange(value, 'byStageName')}
                    >
                        {byStageOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">项目分类</label>
                    <Select
                        placeholder="请选择"
                        allowClear={true}
                        style={{ width: 120 }}
                        value={saveParams.typeName}
                        onChange={value => this.handleChange(value, 'typeName')}
                    >
                        {typeOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">计收入确认方式</label>
                    <Select
                        placeholder="请选择"
                        allowClear={true}
                        style={{ width: 90 }}
                        value={saveParams.contractTypeName}
                        onChange={value => this.handleChange(value, 'contractTypeName')}
                    >
                        {contractTypeListOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">PM</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 140 }}
                        placeholder="输入姓名/工号检索"
                        value={saveParams.pm}
                        params={{ limit: 20 }}
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={value => this.handleChange(value, 'pm')}
                    />
                </div>
                <div className="search-item">
                <label className="ui-label">业务线</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 120}}
                    className="multiple-stage"
                    value={saveParams.lineOfBusiness}
                    onChange={value => this.handleChange(value, 'lineOfBusiness')}
                >
                    {businessOption}
                </Select>
            </div>
            <div className="search-item">
                <label className="ui-label">执行业务线二级分类</label>
                <Select
                    allowClear={true}
                    filterOption={false}
                    placeholder="请选择"
                    style={{width: 120}}
                    value={saveParams.secondLineName}
                    disabled={!saveParams.lineOfBusiness}
                    onChange={value => this.handleChange(value, 'secondLineName')}
                >
                    {secondLineOption}
                </Select>
            </div>
            <div className="search-item">
                <label htmlFor="" className="ui-label">项目领域</label>
                <Select
                    placeholder="请选择"
                    allowClear={true}
                    value={saveParams.investigationAreaId}
                    style={{ width: 120 }}
                    onChange={value => this.handleChange(value, 'investigationAreaId')}
                    >
                        {areaListOption}
                </Select>
            </div>
            <div className="search-item">
                <label htmlFor="" className="ui-label">疾病</label>
                {
                    saveParams.investigationAreaId ?
                            <AutoComplete
                                onSearch={this.loadDiseaseList}
                                allowClear={true}
                                style={{width: 120}}
                                optionLabelProp="showValue"
                                placeholder="输入名称检索"
                                onChange={value => this.handleChange(value, 'diseaseId')}
                            >
                            {diseaseOption}
                        </AutoComplete>
                        :
                        <Input
                            placeholder="请输入"
                            style={{width: 120}}
                            value={saveParams.diseaseName}
                            onChange={e => this.handleChange(e.target.value, 'diseaseName')}
                            onKeyPress={this.enterSearch}
                        />
                }
            </div>
            <div className="search-item">
                <label htmlFor="" className="ui-label">领域leader</label>
                <SearchRetrieve
                    keyword='leaderName'
                    style={{ width: 140 }}
                    placeholder="输入姓名/工号检索"
                    value={saveParams.leaderName}
                    params={{ limit: 20 }}
                    url={API_URL.user.queryLeaderListForSearch}
                    config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                    onChange={value => this.handleChange(value, 'leaderName')}
                />
            </div>
            <div className="search-item">
                <label className="ui-label">异常原因</label>
                <Select
                    placeholder="请选择"
                    style={{ width: 150 }}
                    value={saveParams.reason}
                    allowClear
                    onChange={(value) => this.handleChange(value, "reason")}
                >
                    {errorOption}
                </Select>
            </div>
            <div className="search-item">
                <Button type="primary" disabled={!operable} onClick={this.search}>搜索</Button>
                <Button type="primary" disabled={!operable} onClick={this.props.export}>导出</Button>
            </div>
        </div>
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/financeManagement/financialAnomalyReport/Filter.js